/**
 * Maersk Brand Colors and Theme Constants
 */

// Every colour maps to a Maersk Design System (MDS) token; the tokens are loaded once in src/index.js.
// Values are CSS variables, so don't append hex alpha (`${COLORS.x}12`) — use the *Weak / hover tokens instead.
const mds = (name) => `var(--mds_brand_appearance_${name})`;

export const COLORS = {
  primary: mds('primary_default_background-color'),
  onPrimary: mds('primary_default_on-background-color'),
  primaryWeak: mds('primary_weak_background-color'),
  accent: mds('secondary_default_background-color'), // Maersk cyan: use sparingly
  accentWeak: mds('secondary_weak_background-color'),
  link: mds('primary_default_link-color'),
  gray: mds('neutral_weak_text-color'),
  lightGray: mds('neutral_weak_background-color'),
  background: mds('neutral_weakest_background-color'),
  backgroundLight: mds('neutral_weak_background-color'),
  border: mds('neutral_default_border-color'),
  borderLight: mds('neutral_weak_border-color'),
  borderStrong: mds('primary_default_border-color'),
  hover: mds('state_neutral_weakest_opacity_hover_background-color'),
  white: mds('neutral_default_background-color'),
  black: mds('neutral_default_text-color'),
  text: mds('neutral_default_text-color'),
  textSecondary: mds('neutral_weak_text-color'),
  error: mds('error_default_text-color'),
  errorBg: mds('error_weak_background-color'),
  errorBorder: mds('error_weak_border-color'),
  warning: mds('warning_default_background-color'),
  warningBg: mds('warning_weak_background-color'),
  warningText: mds('warning_weak_on-background-color'),
  success: mds('success_default_text-color'),
  successBg: mds('success_weak_background-color'),
  info: mds('info_default_text-color'),
  infoBg: mds('info_weak_background-color'),
  infoText: mds('info_weak_on-background-color'),
};

export const SPACING = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 20,
  xxl: 24,
  xxxl: 32,
};

export const FONT_SIZES = {
  xs: 11,
  sm: 12,
  md: 13,
  base: 14,
  lg: 15,
  xl: 16,
  xxl: 28,
};

export const FONT_WEIGHTS = {
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
};

export const BORDER_RADIUS = {
  sm: 4,
  md: 6,
  lg: 8,
  xl: 12,
  full: '50%',
};

const mdsShadow = (level) => ['first', 'second', 'third'].map((layer) => {
  const t = (prop) => `var(--mds_brand_appearance_shadow_${level}_${layer}-layer_${prop})`;
  return `${t('offset-x')} ${t('offset-y')} ${t('blur-radius')} ${t('spread-radius')} ${t('color')}`;
}).join(', ');

export const SHADOWS = {
  sm: mdsShadow('low'),
  md: mdsShadow('low'),
  lg: mdsShadow('medium'),
  xl: mdsShadow('high'),
  cyan: mdsShadow('low'),
  cyanHover: mdsShadow('medium'),
};

export const TRANSITIONS = {
  fast: '0.15s ease',
  base: '0.2s ease',
  slow: '0.3s ease',
};

export const FONT_FAMILY = 'var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback)';
export const HEADLINE_FONT_FAMILY = 'var(--mds_brand_typography_headline_font-family), var(--mds_brand_typography_headline_font-family-fallback)';
